'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var idCounter = 0;

function idGen() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var id = ++idCounter;
  return '' + (prefix + id);
}

exports.default = idGen;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/idGen.js